var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"hamburger",class:{'is-active':_vm.isActive},on:{"click":_vm.toggleClick}},[_c('svg-icon',{attrs:{"icon-class":"menu-outline","class-name":"menu-icon"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }